import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Switch,
  useToast,
  VStack,
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
} from "@chakra-ui/react";
import { TenantWithLicenses } from "../Tenants/TenantModel";
import { UpdateTenantBasicDetail} from "../../../services/SuperAdminServices/TenantService";
import { useAppContext } from "../../../context/AppContext";

// this is model for the Edit the Tenant  Basic Details

interface TenantBasicDetailsProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: () => void;
  tenantbasicDetails: TenantWithLicenses["BasicDetails"] | null;
}

const TenantBasicDetails: React.FC<TenantBasicDetailsProps> = ({
  isOpen,
  onClose,
  onSave,
  tenantbasicDetails,
}) => {
  const [formData, setFormData] = useState<TenantWithLicenses["BasicDetails"]>({
    Id: 0,
    TenantID: "",
    Name: "",
    Description: "",
    PhoneNumber: "",
    Email: "",
    Address: "",
    TeamAppId:"",
    IsActive: true,
    IsTrial: false,
    DailyProcessLimitPerUser: 10,
  });
  const { accessToken } = useAppContext();

  const toast = useToast();

  useEffect(() => {
    if (tenantbasicDetails) {
      setFormData(tenantbasicDetails);
    }
    console.log("tenantbasicDetails:::::;;", tenantbasicDetails)
  }, [tenantbasicDetails]);
  

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleTrialSwitchChange = () => {
    setFormData((prev) => ({ ...prev, IsTrial: !prev.IsTrial }));
  };

  const handleDailyLimitChange = (_: string, value: number) => {
    setFormData((prev) => ({
      ...prev,
      DailyProcessLimitPerUser: Number.isNaN(value) ? value : value,
    }));
  };

  const handleSubmit = async () => {debugger;
    if (!tenantbasicDetails) return;
  
    // Re-construct the full TenantWithLicenses payload:
    // const updatedTenant: TenantWithLicenses = {
    //   Id: tenantbasicDetails.Id,
    //   BasicDetails: formData,
    // };
  
    try {

      console.log("Data To update teant basic details:", formData)
      await UpdateTenantBasicDetail(formData, accessToken);
      toast({
        position: "top",
        title: "Tenant details updated.",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      onSave();
      onClose();
    } catch (error) {
      toast({
        title: "Error updating tenant details.",
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    }
  };
  
  

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Edit Tenant Basic Details</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <VStack spacing={4} align="stretch">
            <FormControl>
              <FormLabel>Tenant ID</FormLabel>
              <Input
                name="TenantID"
                value={formData.TenantID}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                name="Name"
                value={formData.Name}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>MSTeams ID</FormLabel>
              <Input
                name="TeamAppId"
                value={formData.TeamAppId}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Input
                name="Description"
                value={formData.Description}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Phone Number</FormLabel>
              <Input
                name="PhoneNumber"
                value={formData.PhoneNumber}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Email</FormLabel>
              <Input
                name="Email"
                value={formData.Email}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Address</FormLabel>
              <Input
                name="Address"
                value={formData.Address}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl display="flex" alignItems="center">
              <FormLabel htmlFor="IsActive" mb="0">
                Active
              </FormLabel>
              <Switch
                id="IsActive"
                name="IsActive"
                isChecked={formData.IsActive}
                onChange={handleChange}
              />
            </FormControl>
            <FormControl display="flex" alignItems="center">
              <FormLabel htmlFor="IsTrial" mb="0">
                Trial Account
              </FormLabel>
              <Switch
                id="IsTrial"
                isChecked={formData.IsTrial}
                onChange={handleTrialSwitchChange}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Daily Process Limit Per User (mails and documents each)</FormLabel>
              <NumberInput
                value={formData.DailyProcessLimitPerUser}
                min={1}
                onChange={handleDailyLimitChange}
                isDisabled={!formData.IsTrial}
              >
                <NumberInputField />
                <NumberInputStepper>
                  <NumberIncrementStepper />
                  <NumberDecrementStepper />
                </NumberInputStepper>
              </NumberInput>
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button colorScheme="blue" mr={3} onClick={handleSubmit}>
            Save
          </Button>
          <Button variant="ghost" onClick={onClose}>
            Cancel
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default TenantBasicDetails;
